import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=2b384af4&scoped=true&"
import script from "./BaseTab.vue?vue&type=script&lang=js&"
export * from "./BaseTab.vue?vue&type=script&lang=js&"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=2b384af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b384af4",
  null
  
)

component.options.__file = "BaseTab.vue"
export default component.exports